<template>
  <div>
    <v-form>
      <v-row>
        <v-col>
          <v-row
            class="pt-6 ps-3 py-0"
          >
            <v-col
              cols="12"
              md="9"
            >
              <v-text-field
                v-model="customer.tbCodigo"
                label="Código"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="pt-5"
            >
              <v-chip
                :color="customer.tbStatus ? 'success' : 'error'"
                :append-icon="customer.tbStatus ? 'mdi-check-bold' : 'mdi-exclamation-thick'"
                dark
              >
                {{ customer.tbStatus ? 'Registro Ativo' : 'Registro Inativo' }}
              </v-chip>
            </v-col>
          </v-row>
          <v-col
            cols="12"
            md="12"
            class="py-0"
          >
            <v-text-field
              v-model="customer.tbDescricao"
              label="Descrição"
              outlined
              dense
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="py-0"
          >
            <v-text-field
              v-model="customer.tbRazaoSocial"
              label="Razão Social"
              outlined
              dense
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="py-0"
          >
            <v-text-field
              v-model="customer.tbEndereco"
              label="Endereço"
              outlined
              dense
              readonly
            />
          </v-col>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="8"
              class="pb-0"
            >
              <v-text-field
                v-model="customer.tbBairro"
                label="Bairro"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="pb-0"
            >
              <v-text-field
                v-model="customer.tbCep"
                label="CEP"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="10"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbCidade"
                label="Cidade"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbUf"
                label="UF"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbCNPJ"
                label="CNPJ"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbInscricao"
                label="Inscrição Estadual"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="4"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbTelefone"
                label="Telefone"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbFax"
                label="Fax"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbContato"
                label="Contato"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-col
            cols="12"
            md="12"
            class="pb-0"
          >
            <v-text-field
              v-model="customer.tbSite"
              label="Web Site"
              outlined
              dense
              readonly
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="py-0"
          >
            <v-text-field
              v-model="customer.tbEmail"
              label="E-mail"
              outlined
              dense
              readonly
            />
          </v-col>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="customer.tbUsuarioSite"
                label="Usuário"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="customer.tbSenhaSite"
                label="Senha"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
        </v-col>
        <v-divider
          vertical
          style="margin-top: 20px;"
        />
        <v-col>
          <v-row
            class="pt-6 ps-3 pe-3 py-0"
          >
            <v-col
              cols="12"
              md="6"
              class="pt-3 pb-0"
            >
              <v-text-field
                v-model="customer.tbDataAssinatura"
                label="Data Assinatura do Contrato"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pt-3 py-0"
            >
              <v-text-field
                v-model="customer.tbClienteDesde"
                label="Cliente Desde"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbNomeMedico"
                label="Médico Responsável"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbEmailMedico"
                label="Email"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbDataNascMedico"
                label="Dt. Nasc"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbCelularMedico"
                label="Celular"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-divider
            class="pb-0 mt-0"
          />
          <v-row class="ps-3 pe-3 pt-6 py-0">
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbNomePrincipal"
                label="Contato Principal"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="4"
              class="py-0 my-0"
            >
              <v-text-field
                v-model="customer.tbEmailPrincipal"
                label="Email"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbDataNascPrincipal"
                label="Dt. Nasc"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbCelularPrincipal"
                label="Celular"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-divider
            class="pb-0 pt-0"
          />
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              class="pt-6 py-0"
            >
              <v-text-field
                v-model="customer.tbEndInternet"
                label="End Internet"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbUsuarioEmulador"
                label="Usuário"
                outlined
                dense
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbSenhaEmulador"
                label="Senha"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbOBSEmulador"
                label="Obs"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
          <v-row class="ps-3 pe-3 py-0">
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="customer.tbSenhaWindwos"
                label="Senha windows"
                outlined
                dense
                readonly
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
  export default {
    name: 'RegistrationData',
    props: {
      customer: {
        type: Object,
        required: true,
      },
    },
  }
</script>
